import styled from "styled-components";
import {
  INVEST,
  INVESTMENT_PLANS,
  INVESTMENTS,
  LOANS,
  WALLET,
} from "../../../constants/constants";
import { loanActions } from "../../../constants/options";
import { useTitle } from "../../../hooks/common/useTitle";
import {
  IsBorrower,
  IsInvestor,
  IsOnboared,
} from "../../../utils/permissionUtils";
import { QuickActions } from "../../common/QuickActions";
import { AnimateChildren, Greeting } from "../../elements/Elements";
import { HorizontalList } from "../../lists/HorizontalList";
import { ListHandler } from "../../lists/ListHandler";
import { BalanceCard } from "../wallet/BalanceCard";
import { InvestorBalanceCard } from "../wallet/InvestorBalanceCard";
import { OnboardCard } from "../../elements/CardElements";
import { BorrowerDashboardCard } from "./BorrowerDashboardCard";
import { InvestorDashboardCard } from "./InvestorDashboardCard";

export const HomePage = () => {
  useTitle();

  const getUserDashboard = () => {
    if (IsInvestor()) {
      return (
        <>
          <BalanceCard action={{ to: INVEST, label: INVEST }} />
          <HorizontalList source={INVESTMENT_PLANS} />
          <InvestorBalanceCard />
          <InvestorDashboardCard />
          <ListHandler source={INVESTMENTS} summary />
        </>
      );
    } else if (IsBorrower()) {
      return (
        <>
          <BalanceCard action={{ to: WALLET, label: "Top Up" }} />
          <QuickActions actions={loanActions} />
          <BorrowerDashboardCard />
          <ListHandler source={LOANS} title="Recent Loans" summary />
        </>
      );
    }
  };

  return (
    <div className="container1">
      <div className="p15 flexColumn gap15">
        <TopWrapper className="gap15">
          <AnimateChildren>
            <Greeting />
            {!IsOnboared() && <OnboardCard />}
            {getUserDashboard()}
          </AnimateChildren>
        </TopWrapper>
      </div>
    </div>
  );
};

const TopWrapper = styled.div`
  display: grid;
  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`;